var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Log in with your Spotify account")]),_c('a',{attrs:{"href":_vm.authUrl}},[_c('v-btn',[_vm._v("Log in")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }